export default (state: { auth: { user: bb.model.IUser } }) => {
  return state.auth.user;
};
